import { faCalendarAlt, faHistory, faPills, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Tabs } from 'antd'
import React, { useState } from 'react'
import usePatChronicMeds from '../../hooks/usePatChronicMeds'
import '../Styling/MobileMedications.css'

const MobMedicationsList = () => {
  const { chronicMeds } = usePatChronicMeds()
  const [activeTab, setActiveTab] = useState('1')

  const items = [
    {
      key: '1',
      label: 'Current',
      children: (
        <div className='medications-list'>
          {chronicMeds.length === 0 ? (
            <div className='empty-state'>
              <FontAwesomeIcon icon={faPills} size='2x' />
              <p>No current medications</p>
            </div>
          ) : (
            <div className='empty-state'>
              <p>Your current medications are displayed above</p>
            </div>
          )}
        </div>
      )
    },
    {
      key: '2',
      label: 'History',
      children: (
        <div className='medications-list'>
          <div className='empty-state'>
            <FontAwesomeIcon icon={faHistory} size='2x' />
            <p>No medication history available</p>
          </div>
        </div>
      )
    },
    {
      key: '3',
      label: 'Prescriptions',
      children: (
        <div className='medications-list'>
          <div className='empty-state'>
            <FontAwesomeIcon icon={faCalendarAlt} size='2x' />
            <p>No prescriptions available</p>
          </div>
        </div>
      )
    }
  ]

  return (
    <div className='medications-list-container'>
      <Tabs activeKey={activeTab} onChange={setActiveTab} items={items} className='medications-tabs' />
      <div className='add-medication'>
        <Button type='primary' icon={<FontAwesomeIcon icon={faPlus} />} size='large'>
          Add Medication
        </Button>
      </div>
    </div>
  )
}

export default MobMedicationsList
